<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1zcX8a/tc-custom/9781440506963.jpg?1730517606472" alt="This image is the cover for the book Best Sex of Your Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Best Sex of Your Life
      </h1>
      <p class="bookDescription body article font2">
        <p>In this book, noted sex experts Jennifer and Dan reveal 101 salacious secrets for delightful encounters between the sheets. You have sex; and sure, it's okay, maybe occasionally even good. But with this new guide they help you kick it up a notch to have the best sex every time.<br/><br/>Featuring plenty of tips guaranteed to make you blush, you'll learn to get in touch with your inner seductress for orgasmic results. Among the secrets revealedwhy you should...Have sex in front of a mirrorLearn to use all four phases of the female orgasmWatch porn with your manTry some new positionslike the deck chairUse household items (hello spatula and rolling pin!) during foreplay If you're tired of bland, predictable sex, this insider's roadmap to a more satisfying ride will have you screaming, squirting, and spending the day (or week...or month!) in bed.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jennifer Hunt, Dan Baritchi, Nancy J. Price, Betsy Bailey
      </h2>
      
      <p class="authorDescription body article">An Adams Media author.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Adams Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?307b1843